import React, { useState, useEffect } from 'react';

function CmpsAnimation({wait, children, last=false}) {
  const [show, setShow] = useState(false);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, wait);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`msg-animate ${show ? 'show' : ''} ${last ? 'last' : ''}`}>
      {children}
    </div>
  );
  
} 

export default CmpsAnimation;